import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Loading from './components/Loading';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <StrictMode>
    <React.Suspense fallback={<Loading message="Initializing Hegra Vision..." />}>
      <App />
    </React.Suspense>
  </StrictMode>
);
